import { ListGoal } from "./types";

export const timeValueToXP = (duration: number) => {
    const minutes = Math.floor(duration / 1000 / 60);
    return Math.floor(minutes / 3);
}

export const getRewardLevel = (g: ListGoal): number =>
    g.completedXP >= g.l3Target 
        ? 3
        : g.completedXP >= g.l2Target 
            ? 2
            : g.completedXP >= g.l1Target 
                ? 1
                : 0;

export const getRewardValue = (g: ListGoal): number => {
    switch (getRewardLevel(g)) {
        case 3:  return g.l3CurrencyReward;
        case 2:  return g.l2CurrencyReward;
        case 1:  return g.l1CurrencyReward;
        default: return 0;
    }
};